import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087705.svg";
import buttonArrowIcon from "@assets/images/Frame-91.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import whatsappIcon from "@assets/images/whatsapp-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import { HeroBadge } from "@components/ui";
import {
  HeroSection,
  ConnectionStepsSection,
  WhoCanApplySection,
  TransparentFeesSection,
  ProcessingTimelineSection,
  CertifiedSection,
  EmergencyCTASection,
} from "../../components";

export function NewConnections() {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Need a New Gas Connection?"
        description="Whether you're setting up a new home, restaurant, or commercial facility, Gas Integrated Solutions L.L.C. (GIS)."
        heroImage={heroImage}
        cta={
          <button className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-2 bg-[#090d2c] rounded-[40px] text-[20px] lg:text-[24px] tracking-[-0.04em] text-white font-albert-sans hover:bg-[#3d405e] transition-colors">
            <span>Apply for New Connection</span>
            <img
              src={buttonArrowIcon}
              alt=""
              className="w-10 rounded-full"
            />
          </button>
        }
        badge={
          <HeroBadge
            text="We provide safe, certified, and efficient gas connections across the UAE, delivered and activated quickly by our licensed technicians."
            linkText="Talk to Our Team"
          />
        }
      />
      <ConnectionStepsSection />
      <WhoCanApplySection />
      <TransparentFeesSection />
      <ProcessingTimelineSection />
      <CertifiedSection />
      <EmergencyCTASection
        title="Smell Gas or Need Help?"
        subtitle={
          <>
            Call our 24/7 Emergency Line: 800-GASIS (42747)
            <br />
            or report a concern via our Online Safety Form.
          </>
        }
      >
        {/* Contact Card */}
        <div className="rounded-3xl bg-white flex flex-col items-start p-6 gap-4">
          <div className="flex items-center gap-2.5">
            <img src={mailIcon} alt="" className="w-5 h-5" />
            <span className="text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
              help@gasis.ae
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <img src={whatsappIcon} alt="" className="w-5 h-5" />
            <span className="text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
              Support (8 AM – 8 PM)
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <img src={buildingIcon} alt="" className="w-5 h-5" />
            <span className="text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
              Sunday – Thursday (8 AM – 6 PM)
            </span>
          </div>
        </div>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default NewConnections;
